import { Modal, notification } from "antd";
import { ApolloError } from "apollo-client";
import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { FilterStore } from "../FilterStore";

export class ShareEduOfferUsersStore {
  loading = false;
  adding = false;

  filterStore: FilterStore;

  filter: any = {
    page: 0,
    size: 2000,
  };

  sortedInfo = { columnKey: "createDate", order: "descend" };

  data = {
    total: 0,
    items: [],
  };

  constructor() {
    makeAutoObservable(this, {
      pagination: computed,
    });
    this.filterStore = new FilterStore(this);
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  @action onSearch(history) {
    this.onPage(history, 1, this.filter.size);
  }

  @action onPage(history, page, size) {
    const query = new URLSearchParams({ ...this.filter, page: page - 1, size });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);
    console.log("query", params);
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "20");

    this.filter = { page, size };
    this.refresh();
  }

  @action
  addEmail(email) {
    this.adding = true;
    return Api.user
      .setShareEduOffer({ email })
      .then(() => {
        notification.success({ message: `Successfully` });
        setTimeout(() => this.refresh(), 3000);
      })
      .catch((err: ApolloError) => {})
      .finally(() => (this.adding = false));
  }

  @action
  delUser(userId) {
    Modal.confirm({
      content: "Are you sure to delete this user?",
      onOk: () => {
        return Api.user.updateUserIsShareEduOffer({ userId, isShareEduOffer: false }).then(() => {
          notification.success({ message: `Deleted Successfully` });
          setTimeout(() => this.refresh(), 3000);
        });
      },
    });
  }

  @action
  refresh() {
    this.loading = true;
    const { page, size } = this.filter;

    const sorts = this.sortedInfo.order
      ? [{ field: this.sortedInfo.columnKey, order: this.sortedInfo.order === "descend" ? "desc" : "asc" }]
      : undefined;

    const filter: any = {
      page,
      size,
      isShareEduOffer: true,
      sorts,
    };

    Api.user
      .users(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.users;
        });
      })
      .finally(() => (this.loading = false));
  }
}

export const shareEduOfferUsersStore = new ShareEduOfferUsersStore();
